"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEditProductTreeNode = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
const gql_1 = require("../gql");
const useEditProductTreeNode = () => {
    const [editProductTreeMutation, data] = (0, react_2.useMutation)(gql_1.EDIT_PRODUCT_TREE_NODE);
    const editProductTree = (0, react_1.useCallback)((...args) => editProductTreeMutation(...args), [editProductTreeMutation]);
    return Object.assign({ editProductTree }, data);
};
exports.useEditProductTreeNode = useEditProductTreeNode;
